<template>
  <v-layout row justify-center class="billingModule">
    <v-flex md3 class="sidebar">
      <aside>
        <span class="patient_profile">
          <h4>{{ptName}}</h4>
          <h5>{{ptAge}}/{{ptGender}} <span v-if='ptPlace !== "undefined"'>, {{ptPlace}}</span> </h5>
        </span>
        <ul>
          <li :class="(this.fromCompleted) ? 'fromCompleted' : 'notfromCompleted'">
            <router-link
            :to="{
              name: 'vitalsPost',
              params: {
                status:`${vitalsStatus}`,
                appId: `${appId}`,
                ptId: `${ptId}`}
              }"
              >
              Vitals
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'prescription', params: {appId: `${appId}`,ptId: `${ptId}`} }">Prescriptions</router-link>
          </li>
          <!-- <li class="active">
            <router-link :to="{ name: 'billing', params: {appId: `${appId}`,ptId: `${ptId}`}}">Billing</router-link>
          </li> -->
        </ul>
      </aside>
    </v-flex md3>

    <v-flex md9 pl-3 pr-3 v-if='masterBillExists'>
      <!-- <masterBill /> -->
    </v-flex>
    <v-flex md9 pl-3 pr-3 v-else>
      <!-- <additionalBill /> -->
    </v-flex>
  </v-layout>
</template>
<script>
import Vue from 'vue'
import {
  api
} from '../api.js';
import {
  mapState
} from 'vuex';
import {
  axios,
  get,
  post
} from 'axios';
import _ from 'lodash';
import masterBill from './masterBill.vue';
import allBills from './allBills.vue';
import additionalBill from './additionalBill.vue';

export default {
  components: {
    masterBill,
    allBills,
    additionalBill
  },
  data() {
    return {
      billingTotal: 2,
      dialog: false,
      valid: true,
      selectionChange: '',
      a1: {
        name: '',
        amount: ''
      },
      customStuffLoad: '',
      charges: this.charges,
      filteredCharges: this.filteredCharges,
      bills: '',
      itemTotal: '',
      option: '',
      items: [{
          message: 'Consultation Fee',
          amount: '1'
        },
        {
          message: 'Admission Fee',
          amount: '1'
        },
        {
          message: 'BP Check',
          amount: '1'
        }
      ],
      headers: [{
          text: 'Visit Date',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Bill Amount',
          align: 'center',
          sortable: false
        },
        {
          text: 'Amount Paid',
          align: 'center',
          sortable: false
        },
        {
          text: 'Outstanding Amount',
          align: 'center',
          sortable: false
        }
      ],
      dataTable: [{
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        },
        {
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        }, {
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        }, {
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        }, {
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        }, {
          value: false,
          date: '01 Jan 2017',
          billAmount: 300,
          amountPaid: 160,
          outstanding: 24
        }
      ]
    }
  },
  computed: {
    multiply: function(a, b) {
      console.log(a, b)
      return a * b
    },
    masterBillExists: function() {
      const BillExistence = localStorage.getItem("billingStatus")
      if (BillExistence === "not yet started")
        return true
    },
    vitalsStatus: function() {
      const vitalsStatus = localStorage.getItem("vitalsStatus")
        return vitalsStatus
    },
    appId: function() {
      if (this.$route.params.appId !== null) {
        return this.$route.params.appId
      }
    },
    ptId: function() {
      if (this.$route.params.ptId !== null) {
        return this.$route.params.ptId
      }
    },
    billingTotals: function() {
      let arr = this.filteredCharges
      let sumOfitemTotals = 0;
      for (const i in arr) {
        sumOfitemTotals += (arr[i].amount * arr[i].quantity)
      }
      return sumOfitemTotals
    },
    whatever: function() {
      return this.sumOfitemTotals
    },
    ptName: function() {
      return localStorage.getItem("ptName")
    },
    ptAge: function() {
      return localStorage.getItem("ptAge")
    },
    ptGender: function() {
      return localStorage.getItem("ptGender")
    },
    ptPlace: function() {
      return localStorage.getItem("ptPlace")
    },
    fromCompleted: function() {
      const string = "completed queue"
      const from = localStorage.getItem("from_where")
      return from.includes(string)
    }
  },
  mounted() {
    // get(api + `/clinic_charges?person_id=${this.ptId}`)
    //   .then(res => {
    //     this.charges = res.data.charge_list
    //     this.filteredCharges = this.charges.filter(charge => charge.is_admission === 1 || charge.is_default === 1);
    //   })
  },



}

</script>
<style media="screen">
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.listOfCharges {
  display: flex;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

/* .card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
} */

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals>h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383B3F;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #F2994A;
}

.patient_profile>h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile>h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: space-around;
}

.autocompleteSelect {
  width: 65%;
}

.fromCompleted {
   pointer-events:none;
   opacity:0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/billingModule.vue